import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '../../_services';
import { first } from 'rxjs/operators';
import { emailValidator, passwordMatchValidator } from '../../_validators/validators';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})
export class RegisterComponent implements OnInit {
  registerForm: FormGroup;
  accountActivationUrl: string;
  submitted: boolean;
  loading: boolean;
  error: '';
  public registerSuccess: boolean;
  regResponse: any;

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService,
  ) {
    this.registerForm = this.formBuilder.group({
      username: ['', [Validators.required, Validators.minLength(4)]],
      email: ['', [Validators.required, emailValidator]],
      password: ['', [Validators.required, Validators.minLength(8)]],
      password_confirmation: ['', [Validators.required, passwordMatchValidator]]
    });

    this.d.password.valueChanges
      .subscribe(c => this.d.password_confirmation.updateValueAndValidity());
  }

  ngOnInit(): void {
    this.registerSuccess = false;
    this.accountActivationUrl = 'activate-account';
  }

  get d() {
    return this.registerForm.controls;
  }

  registerUser() {

    if (this.registerForm.invalid) {
      return;
    }

    this.authenticationService.register(this.d.username.value, this.d.email.value, this.d.password.value, false)
      .pipe(first())
      .subscribe(response => {
        this.router.navigate([this.accountActivationUrl]);
        /*this.regResponse = response;
        this.registerSuccess = true;*/
      }, error => {
        this.error = error;
        this.loading = false;
      });
  }
}
